import { type CalendarDate, parseAbsolute, parseDate, parseDateTime, toCalendarDate } from "@internationalized/date";

const DATE_PARSERS: ((value: string) => CalendarDate)[] = [parseDate, value => toCalendarDate(parseDateTime(value)), value => toCalendarDate(parseAbsolute(value, "UTC"))];

export function parseRuleDate(value: string): CalendarDate | null {
    if (!value.trim()) {
        return null;
    }

    for (const parser of DATE_PARSERS) {
        try {
            return parser(value);
        } catch {}
    }

    return null;
}

export function formatRuleDate(value: CalendarDate | null): string {
    return value ? value.toString() : "";
}

export function parseRuleNumber(value: string): number {
    return value.trim() ? Number(value) : NaN;
}

export const RULE_NUMBER_FRACTION_DIGITS = 20;

const ruleNumberFormatter = new Intl.NumberFormat("en-US", { useGrouping: false, maximumFractionDigits: RULE_NUMBER_FRACTION_DIGITS });

export function formatRuleNumber(value: number): string {
    return Number.isNaN(value) ? "" : ruleNumberFormatter.format(value);
}
